<template>
    <div class="tips-box">
        <div class="tips-view">
            {{text}}
        </div>
    </div>
</template>

<script>
export default {
    name: "Tips",
    props: {
        text: {
            type: String,
            default: "当前筛选条件下，该按钮不可选。如需参与筛选，请点击重置按钮"
        },
        isTips: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {

        }
    },
    created () {

    },
    mounted () {

    },
    methods: {

    },
    watch: {
        'isTips': {
            handler (n, o) {
                if(n) {
                    let _this = this;
                    setTimeout(() => {
                        _this.$emit('closeTips');
                    }, 3000)
                }
            },
            immediate: true
        }
    }
}
</script>

<style lang="less" scoped>
    .tips-box {
        position: fixed;
        top: 94px;
        left: 0;
        z-index: 99999;
        display: flex;
        justify-content: center;
        width: 100%;

        .tips-view {
            display: flex;
            align-items: center;
            padding-left: 60px;
            padding-right: 29px;
            min-width: 300px;
            height: 68px;
            background: #fff url(./../../assets/jiaobiao.png) no-repeat;
            background-position: 20px 20px;
            background-size: 30px auto;
            border-radius: 9px;
            font-size: 24px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #5F667A;
        }
    }
</style>